<template>
  <div id="bar" :style="styles"></div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
import echarts_config from "@/configs/echarts.config";

export default {
  name: "bar",
  props: {
    axis_name: String,
    series_name: String,
    projects: Array,
    grid: Array,
    styles: String,
    is_loading: Boolean,
  },
  data() {
    return {
      chart: {},
    };
  },
  watch: {
    projects(new_val) {
      this.chart.showLoading();
      this.projects = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("bar"));
    this.chart.showLoading();
  },
  methods: {
    draw() {
      if (!this.projects) return;

      const _this = this;
      let yAxisData = [],
        seriesData = [];
      for (let project of _this.projects) {
        yAxisData.push(Object.values(project)[0]);
        seriesData.push(Object.values(project)[1]);
      }

      const option = {
        color: ["#00578F"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (params) => {
            let list = [];
            if(params && params.length > 0)
            {
              list.push('<span style="font-size:12px;color:#6e7079;margin-left:2px">' + params[0]?.name + '</span><div style="clear:both"></div>')
            }
            let listItem = "";
            list.push(
              params[0].marker +
                '<span style="font-size:12px;color:#6e7079;margin-left:2px">' +
                params[0].seriesName
                +
                '</span>：' +
                '<span style="font-size:12px;margin-left:5px;">' +
                params[0].value.toLocaleString() +
                "</span>" +
                '<div style="clear:both"></div>'
            );
            listItem = list.join("");
            return listItem;
          },
        },
        legend: {
          show: false,
        },
        grid: _this.grid,
        xAxis: [
          {
            type: "value",
            show: false,
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: {
          name: _this.axis_name,
          nameTextStyle: {
            color: "#333333",
            padding: [0, 0, -10, 0],
          },
          axisLine: {
            lineStyle: {
              color: "#DDDDDD",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#333333",
            },
          },
          axisTick: {
            show: false,
          },
          data: yAxisData.reverse(),
        },
        series: {
          name: _this.series_name,
          type: "bar",
          barWidth: 12,
          barCategoryGap: 30,
          label: echarts_config.seriesLabelConfig,
          data: seriesData.reverse(),
        },
      };
      this.chart.setOption(option, true);
      this.chart.hideLoading();
    },
  },
};
</script>
